import PropTypes from 'prop-types'
import { Button, Icon, Logo } from '@artprov/design-system'
import { Link } from 'react-router-dom'
import UserMenuButton from '@/common/components/user-menu/UserMenuButton.jsx'
import { useIsMobileMenu } from '@/common/ds/Menu'

export default function ClientesHeader({
  mobileMenuOpen,
  onMobileMenuToggle,
  showMobileMenuTrigger,
  mobileTriggerRef,
}) {
  const isMobile = useIsMobileMenu()

  return (
    <header className="m-auto flex flex-col items-center bg-tertiary-98">
      <div className="flex h-[72px] w-full items-center justify-between px-6 min-[1025px]:px-24">
        <Link
          to="/"
          aria-label="Ir a la página principal"
          onClick={() => {
            if (mobileMenuOpen) onMobileMenuToggle()
          }}
        >
          {isMobile ? (
            <Logo className="h-8" variant="Iso positivo" />
          ) : (
            <img src="/assets/logoProvinciaART.svg" alt="Provincia ART" className="h-8" />
          )}
        </Link>

        <div className="flex items-center gap-2">
          {isMobile ? (
            <Button
              variant="ghost"
              size="md"
              iconOnly
              startIcon={<Icon icon="notifications" size="small" />}
              type="button"
              aria-label="Notificaciones"
            />
          ) : null}

          {isMobile && showMobileMenuTrigger ? (
            <Button
              ref={mobileTriggerRef}
              variant="ghost"
              size="md"
              iconOnly
              startIcon={<Icon icon={mobileMenuOpen ? 'close' : 'menu'} size="small" />}
              onClick={onMobileMenuToggle}
              type="button"
              aria-label={mobileMenuOpen ? 'Cerrar menú principal' : 'Abrir menú principal'}
              aria-expanded={mobileMenuOpen}
              aria-controls="clientes-main-menu"
            />
          ) : (
            <UserMenuButton />
          )}
        </div>
      </div>
    </header>
  )
}

ClientesHeader.propTypes = {
  mobileMenuOpen: PropTypes.bool.isRequired,
  onMobileMenuToggle: PropTypes.func.isRequired,
  showMobileMenuTrigger: PropTypes.bool.isRequired,
  mobileTriggerRef: PropTypes.shape({ current: PropTypes.object }),
}
